'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var prefixCls = 'ivu-page';

function isValueNumber(value) {
  return (/^[1-9][0-9]*$/.test(value + '')
  );
}

exports.default = {
  name: 'PageOption',
  props: {
    pageSizeOpts: Array,
    showSizer: Boolean,
    showElevator: Boolean,
    current: Number,
    _current: Number,
    pageSize: Number,
    allPages: Number,
    isSmall: Boolean,
    placement: String,
    transfer: Boolean
  },
  data: function data() {
    return {
      currentPageSize: this.pageSize
    };
  },

  watch: {
    pageSize: function pageSize(val) {
      this.currentPageSize = val;
    }
  },
  computed: {
    size: function size() {
      return this.isSmall ? 'small' : 'default';
    },
    optsClasses: function optsClasses() {
      return [prefixCls + '-options'];
    },
    sizerClasses: function sizerClasses() {
      return [prefixCls + '-options-sizer'];
    },
    ElevatorClasses: function ElevatorClasses() {
      return [prefixCls + '-options-elevator'];
    }
  },
  methods: {
    changeSize: function changeSize() {
      this.$emit('on-size', this.currentPageSize);
    },
    changePage: function changePage(event) {
      var val = event.target.value.trim();
      var page = 0;
      if (isValueNumber(val)) {
        val = Number(val);
        if (val != this.current) {
          var allPages = this.allPages;

          if (val > allPages) {
            page = allPages;
          } else {
            page = val;
          }
        }
      } else {
        page = 1;
      }
      if (page) {
        this.$emit('on-page', page);
        event.target.value = page;
      }
    }
  }
};